import constraints from './constraints';

export default {
  constraints,
};
